export const SERVICES = {
    one_bedroom_property: {
        gka: 'one_bedroom_property',
        service: 'One Bedroom House/Bungalow/Flat/Maisonette',
        price: '10.00',
        duration: 15,
        duration_plus_travel: 30,
        friendly_duration: '15mins',
    },
    two_bedroom_property: {
        gka: 'two_bedroom_property',
        service: 'Two Bedroom House/Bungalow/Flat/Maisonette',
        price: '12.00',
        duration: 15,
        duration_plus_travel: 30,
        friendly_duration: '20mins',
    },
    three_bedroom_property: {
        gka: 'three_bedroom_property',
        service: 'Three Bedroom House/Bungalow/Flat/Maisonette',
        price: '14.00',
        duration: 30,
        duration_plus_travel: 30,
        friendly_duration: '25mins',
    },
    four_bedroom_property: {
        gka: 'four_bedroom_property',
        service: 'Four Bedroom House/Bungalow/Flat/Maisonette',
        price: '16.00',
        duration: 30,
        duration_plus_travel: 60,
        friendly_duration: '30mins',
    },
    five_bedroom_property: {
        gka: 'five_bedroom_property',
        service: 'Five Bedroom House/Bungalow/Flat/Maisonette',
        price: '19.00',
        duration: 45,
        duration_plus_travel: 60,
        friendly_duration: '40mins',
    },
    six_bedroom_property: {
        gka: 'six_bedroom_property',
        service: 'Six Bedroom House/Bungalow/Flat/Maisonette',
        price: null,
        duration_plus_travel: 60,
    },
    two_bedroom_town_house: {
        gka: 'two_bedroom_town_house',
        service: 'Two Bedroom Town House',
        price: '15.00',
        duration: 15,
        duration_plus_travel: 30,
        friendly_duration: '20mins',
    },
    three_bedroom_town_house: {
        gka: 'three_bedroom_town_house',
        service: 'Three Bedroom Town House',
        price: '17.50',
        duration: 30,
        duration_plus_travel: 30,
        friendly_duration: '25mins',
    },
    four_bedroom_town_house: {
        gka: 'four_bedroom_town_house',
        service: 'Four Bedroom Town House',
        price: '20.00',
        duration: 30,
        duration_plus_travel: 60,
        friendly_duration: '30mins',
    },
    five_bedroom_town_house: {
        gka: 'five_bedroom_town_house',
        service: 'Five Bedroom Town House',
        price: '22.50',
        duration: 45,
        duration_plus_travel: 60,
        friendly_duration: '40mins',
    },
    six_bedroom_town_house: {
        gka: 'six_bedroom_town_house',
        service: 'Six Bedroom Town House',
        price: null,
        duration_plus_travel: 60,
    },
};

export const ADDONS = {
    extension_small: {
        id: 'extension_small',
        label: 'Small Conservatory or Extension (approx size: 10x8ft)',
        price: '7.50',
    },
    extension_mid: {
        id: 'extension_mid',
        label: 'Medium Conservatory or Extension (approx size: 10x12ft)',
        price: '10.00',
    },
    extension_large: {
        id: 'extension_large',
        label: 'Large Conservatory or Extension (approx size: 10x15ft)',
        price: '12.50',
    },
    velux_roof_window: {
        id: 'velux_roof_window',
        label: 'Velux Roof Window',
        price: '1.50',
    },
};

export const ADDONS_LIST = [
    {...ADDONS.extension_small},
    {...ADDONS.extension_mid},
    {...ADDONS.extension_large},
];

export default [
    {...SERVICES.one_bedroom_property},
    {...SERVICES.two_bedroom_property},
    {...SERVICES.three_bedroom_property},
    {...SERVICES.four_bedroom_property},
    {...SERVICES.five_bedroom_property},
    {...SERVICES.six_bedroom_property},
    {...SERVICES.two_bedroom_town_house},
    {...SERVICES.three_bedroom_town_house},
    {...SERVICES.five_bedroom_town_house},
    {...SERVICES.six_bedroom_town_house},
];
